import { CharlestonHero } from "@/components/ui/CharlestonHero"
import CharlestonServices from "@/components/ui/CharlestonServices"
import CharlestonWhyUs from "@/components/ui/CharlestonWhyUs"
import CharlestonProcess from "@/components/ui/CharlestonProcess"
import CharlestonTestimonials from "@/components/ui/CharlestonTestimonials"
import CharlestonFAQ from "@/components/ui/CharlestonFAQ"
import { CharlestonCTA } from "@/components/ui/CharlestonCTA"

function Home() {
  return (
    <main className="relative mx-auto flex flex-col">
      <div className="pt-56">
        <CharlestonHero />
      </div>

      <div className="mt-32 px-4 xl:px-0">
        <CharlestonServices />
      </div>

      <div className="mt-32 px-4 xl:px-0">
        <CharlestonWhyUs />
      </div>

      <div className="mt-32 px-4 xl:px-0">
        <CharlestonProcess />
      </div>

      <div className="mt-32 px-4 xl:px-0">
        <CharlestonTestimonials />
      </div>

      <div className="mt-32 px-4 xl:px-0">
        <CharlestonFAQ />
      </div>

      <div className="mt-32 mb-32 px-4 xl:px-0">
        <CharlestonCTA />
      </div>
    </main>
  )
}

export default Home
